import { useState } from 'react';
import { useSelector } from 'react-redux';

import RBCountryFilter from 'components/UniversalFilters/RBCountryFilter';
import PageHeaderLayout from 'screens/system-utils/shared/components/PageHeaderLayout';

import { selectUserCountry } from 'store/auth/selectors';
import useAirtableConfig from '../shared/hooks/useAirtableConfig';

const pageConfig = {
  header: 'Sales Deals Calendar',
  description:
    'Get a quick overview of all your sales deals in a calendar view.',
};

const SalesDealsCalendarView = () => {
  const [selectedCountry, setSelectedCountry] = useState<string | null>(
    useSelector(selectUserCountry),
  );
  const { getUserCountryConfig } = useAirtableConfig(selectedCountry as string);

  return (
    <PageHeaderLayout
      pageConfig={pageConfig}
      renderFilters={() => (
        <RBCountryFilter
          selectedCountry={selectedCountry as string}
          onChange={setSelectedCountry}
        />
      )}
    >
      <iframe
        className="airtable-embed"
        src={getUserCountryConfig().urls?.sragCalendarView || ''}
        width="100%"
        height="700"
        style={{ background: 'transparent' }}
      />
    </PageHeaderLayout>
  );
};

export default SalesDealsCalendarView;
